import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Drawer, IconButton, TextField } from '@mui/material'

import { baseButtonBlueBg } from '../../theme/custom-styles'
import CloseModalIcon from '../../assets/icons/close-modal-icon.svg'

const drawerWidth = 600

export const BackgroundAlertsFindings = ({ alerts }: { alerts: any }) => {
  const { t } = useTranslation(['payments-to-review-management'])

  const [drawerOpened, setDrawerOpened] = useState(false)
  const [selectedAlertData, setSelectedAlertData] = useState<Array<{ keyName: string; value: string }>>([])

  const handleDescamelizeKey = (str: string): string => {
    return str
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/^./, (char) => char.toUpperCase())
  }

  const handleFormatJsonAttributes = (jsonObj: Record<string, any>): { keyName: string; value: any }[] => {
    return Object.keys(jsonObj).map((key) => ({
      keyName: handleDescamelizeKey(key),
      value: jsonObj[key]
    }))
  }

  return (
    <>
      <div
        className="table-header-container"
        style={{ marginTop: '10px', background: 'none', border: 'none' }}
      >
        <div className="customer-company-table-column customer-company-table-width-10 display-none-xlg table-header-text">{t('tableHeaders.id')}</div>
        <div className="customer-company-table-column customer-company-table-width-45 table-header-text">{t('tableHeaders.match')}</div>
        <div className="customer-company-table-column customer-company-table-width-15 table-header-text customer-company-display-none-lg">{t('tableHeaders.score')}</div>
        <div className="customer-company-table-column customer-company-table-width-20 table-header-text customer-company-display-none-sm">{t('tableHeaders.riskLevel')}</div>
        <div className="customer-company-table-column customer-company-table-width-10 table-header-text">{t('tableHeaders.actions')}</div>
      </div>
      <div style={{ gap: '10px', display: 'flex', flexDirection: 'column' }}>
        {alerts.map((alertData: any, index: number) => {
          return (
            <div
              key={index}
              style={{ marginTop: '0px' }}
              className="table-header-container"
            >
              <div className="customer-company-table-column customer-company-table-width-10 display-none-xlg table-row-content-subtitle">{alertData.id}</div>
              <div className="customer-company-table-column customer-company-table-width-45 table-row-content-subtitle">{`${alertData.nombres} | ${alertData.code}`}</div>
              <div className="customer-company-table-column customer-company-table-width-15 table-row-content-subtitle customer-company-display-none-lg">{alertData.score}</div>
              <div className="customer-company-table-column customer-company-table-width-20 table-row-content-subtitle customer-company-display-none-sm">{alertData.riskLevel}</div>
              <div className="customer-company-table-column customer-company-table-width-10 table-row-content-subtitle">
                <Button
                  variant="text"
                  sx={baseButtonBlueBg}
                  onClick={() => {
                    const alertAttributesData = handleFormatJsonAttributes(alertData)
                    setSelectedAlertData(alertAttributesData)
                    setDrawerOpened(true)
                  }}
                >
                  {t('buttonsTexts.viewDetails')}
                </Button>
              </div>
            </div>
          )
        })}
      </div>
      <Drawer
        anchor="right"
        open={drawerOpened}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box'
          }
        }}
        onClose={() => setDrawerOpened(!drawerOpened)}
      >
        <div style={{ padding: '20px 20px 200px', boxSizing: 'border-box' }}>
          <div className="dialog-title-container">
            <IconButton
              edge="end"
              aria-label="toggle password visibility"
              sx={{ color: '#525252' }}
              onClick={() => setDrawerOpened(false)}
            >
              <img
                src={CloseModalIcon}
                alt="close-modal-icon"
              />
            </IconButton>
            <div className="dialog-title">{t('alertDetailsTitle')}</div>
          </div>
          <div style={{ width: '100%', marginTop: '20px', gap: '30px', display: 'flex', flexDirection: 'column' }}>
            {selectedAlertData.map((alertData: { keyName: string; value: any }, index: number) => {
              return (
                <TextField
                  disabled
                  key={index}
                  multiline
                  value={alertData.value}
                  label={alertData.keyName}
                  sx={{
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                    whiteSpace: 'pre-wrap',
                    '& .MuiInputBase-input.Mui-disabled': {
                      color: '#737373',
                      WebkitTextFillColor: '#737373'
                    },
                    '& .MuiInputLabel-root.Mui-disabled': {
                      color: 'g#0e9384ray'
                    }
                  }}
                />
              )
            })}
          </div>
        </div>
      </Drawer>
    </>
  )
}
